export const lineupOrder = store => store.lineupOrder;
